import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';
// Rimuovi l'importazione del CSS originale
// import './GestioneStati.css';
import './tailwind.css';
import logo from './logo.svg'; // Importa il logo
import { FaLock } from 'react-icons/fa'; // Icona per la password

export default function ForcedPasswordChange() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  // Effetto per controllare lo stato di autenticazione all'avvio
  useEffect(() => {
    const checkUser = async () => {
      const { data: { user }, error: authError } = await supabase.auth.getUser();
      if (!user || authError) {
        // Se non c'è utente loggato, reindirizza al login
        navigate('/');
      }
    };
    checkUser();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Le password non corrispondono.');
      return;
    }

    if (newPassword.length < 6) { // Regola di lunghezza minima della password di Supabase
      setError('La password deve essere di almeno 6 caratteri.');
      return;
    }

    try {
      // Aggiorna la password dell'utente nel sistema di autenticazione di Supabase
      const { data: updateAuthData, error: updateAuthError } = await supabase.auth.updateUser({
        password: newPassword
      });

      // --- QUI È IL PUNTO CORRETTO DOVE INSERIRE IL BLOCCO TRADOTTO ---
      if (updateAuthError) {
        let errorMessage = updateAuthError.message;
        if (errorMessage === "New password should be different from the old password.") {
          errorMessage = "la nuova password deve essere diversa da quella attuale."; // La tua traduzione
        }
        console.error('Errore nell\'aggiornamento della password di autenticazione:', errorMessage);
        setError(`Errore nell'aggiornamento della password: ${errorMessage}`);
        return;
      }
      // -----------------------------------------------------------

      // Se l'aggiornamento della password ha avuto successo, aggiorna il flag 'first_login' nella tabella 'utenti'
      const { data: userData, error: userError } = await supabase.auth.getUser();
      if (!userData?.user) {
        setError('Utente non trovato dopo l\'aggiornamento della password.');
        return;
      }
      const userId = userData.user.id;

      const { error: profileUpdateError } = await supabase
        .from('utenti')
        .update({ first_login: false })
        .eq('id', userId);

      if (profileUpdateError) {
        console.error('Errore nell\'aggiornamento del flag first_login:', profileUpdateError.message);
        setError(`Password aggiornata, ma errore nell'aggiornare il profilo: ${profileUpdateError.message}. Contatta l'assistenza.`);
        return;
      }

      setSuccess('Password aggiornata con successo! Verrai reindirizzato alla dashboard.');
      // Reindirizza l'utente alla dashboard corretta dopo un breve ritardo
      setTimeout(async () => {
        // Recupera il ruolo dell'utente dopo l'aggiornamento per il reindirizzamento
        const { data: profilo, error: ruoloError } = await supabase
          .from('utenti')
          .select('ruolo::text')
          .eq('id', userId)
          .single();

        if (ruoloError) {
          console.error('Errore nel recupero del ruolo per il reindirizzamento:', ruoloError.message);
          navigate('/'); // Fallback al login in caso di errore
          return;
        }

        if (profilo?.ruolo === 'broker') {
          navigate('/dashboard/broker');
        } else if (profilo?.ruolo === 'agenzia') {
          navigate('/dashboard/agenzia');
        } else if (profilo?.ruolo === 'agente') { // ⭐ NUOVO CASO PER GLI OPERATORI ⭐
          navigate('/dashboard/agente');
        } else {
          // Ruolo non riconosciuto o altri casi, reindirizza al login
          console.error('Ruolo utente non riconosciuto dopo il cambio password.');
          navigate('/');
        }
      }, 2000);

    } catch (err) {
      console.error('Errore imprevisto nel cambio password:', err.message);
      setError('Si è verificato un errore imprevisto. Riprova.');
    }
  };

  return (
    // Main container, centered on screen
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      {/* Content wrapper, max width for readability and shadow for visual depth */}
      <div className="bg-white p-8 rounded-lg shadow-xl text-center max-w-md w-full">
        <img src={logo} alt="Europassistance" className="mb-4 mx-auto h-20" />
        <h1 className="text-2xl md:text-2xl text-mioblu mb-4 flex items-center justify-center font-semibold uppercase">
          <FaLock className="mr-3 text-miorosso text-3xl" /> Cambia la tua Password
        </h1>
        <p className="text-mioblu mb-6 text-sm">
          Per motivi di sicurezza, devi impostare una nuova password al tuo primo accesso.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {error && (
            <p className="text-miorosso text-sm mb-2">{error}</p>
          )}
          {success && (
            <p className="text-green-500 text-sm mb-2">{success}</p>
          )}

          <label htmlFor="new-password" className="text-left text-gray-700 font-medium text-sm">Nuova Password:</label>
          <input
            id="new-password"
            type="password"
            placeholder="Minimo 6 caratteri"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-gray-800"
          />

          <label htmlFor="confirm-password" className="text-left text-gray-700 font-medium text-sm">Conferma Nuova Password:</label>
          <input
            id="confirm-password"
            type="password"
            placeholder="Conferma Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-gray-800"
          />

          <button
            type="submit"
            className="w-full px-4 py-2 bg-miorosso text-white rounded-md transition-colors duration-300 hover:bg-mioblu focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 font-semibold mt-4"
          >
            Imposta Nuova Password
          </button>
        </form>
      </div>
    </div>
  );
}